<template>
    <div class="orderDetail">
        <div class="page_top">
            <div class="title" @click="back()">
                <i class="icon" id="icon"></i>
                <span class="header-text">訂單明細</span>
            </div>
        </div>
        <div class="page_padding" v-loading="loading" element-loading-spinner="el-icon-loading">
            <div class="container-fluid" v-if="order!= null">
                <!--訂單資訊-->
                <el-card shadow="always" class="my-1">
                    <span class="fw-bold">訂單資訊</span>
                    <el-divider class="my-2"></el-divider>
                    <div style="font-size: 0.9rem">
                        <div class="d-flex justify-content-between fw-bold my-2">
                            <span>訂單號碼</span>
                            <span>{{ order.orderNumber }}</span>
                        </div>
                        <div class="d-flex justify-content-between fw-bold my-2">
                            <span>訂單日期</span>
                            <span>{{ order.createdAt }}</span>
                        </div>
                        <div class="d-flex justify-content-between fw-bold my-2">
                            <span>訂單狀態</span>
                            <span style="color: #F56C6C;font-size: 18px" v-if="order.orderStatus == 5">{{
                                    order.orderStatusName
                                }}</span>
                            <span style="font-size: 18px" v-else>{{ order.orderStatusName }}</span>
                        </div>
                    </div>
                    <el-divider class="my-2"></el-divider>
                    <div class="d-flex justify-content-end">
                        <el-tag v-if="order.payStatus == 0 && order.paymentType == null" class="ms-2"
                                @click="rechekout">重新付款
                        </el-tag>
                        <div v-if="order.payStatus == 0 && order.paymentType == null">
                            <form method="post" ref="payForm">
                                <input type="hidden" name="MerchantID"><br>
                                <input type="hidden" name="TradeInfo"><br>
                                <input type="hidden" name="TradeSha"><br>
                                <input type="hidden" name="Version" value="2.0"><br>
                            </form>
                        </div>
<!--                        <el-tag v-if="order.payStatus == 1 && order.orderStatus ==5" type="danger" class="ms-2"-->
<!--                                @click="dialogVisible2 = true">退貨申訴-->
<!--                        </el-tag>-->
                        <el-tag v-if="order.payStatus == 1 &&  order.orderStatus <=3 && checkCanReturnDate(order.payTime )" type="danger" class="ms-2"
                                @click="returnProductDialogVisible=true">退貨申請
                        </el-tag>
                        <el-tag type="success" class="ms-2" @click="showChatroom">
                            <i class="el-icon-chat-line-round me-1"
                               style="font-size: 1.1rem"></i>線上聊聊
                        </el-tag>
                    </div>
                </el-card>
                <!--付款資訊-->
                <el-card shadow="always" class="my-1">
                    <span class="fw-bold">付款資訊</span>
                    <el-divider class="my-2"></el-divider>
                    <div style="font-size: 0.9rem">
                        <div class="d-flex justify-content-between fw-bold my-2 align-items-center">
                            <span>付款狀態</span>
                            <el-tag size="mini" v-if="order.payStatus==1">{{ order.payStatusName }}</el-tag>
                            <el-tag type="danger" size="mini" v-else>{{ order.payStatusName }}</el-tag>
                        </div>
                        <div class="d-flex justify-content-between fw-bold my-2 align-items-center">
                            <span>付款時間</span>
                            <span>{{ order.payTime }}</span>
                        </div>
                        <div class="d-flex justify-content-between fw-bold my-2">
                            <span>付款方式</span>
                            <span>{{ order.paymentTypeName }}</span>
                        </div>
                        <div v-if="order.paymentType == 'VACC'">
                            <div class="d-flex justify-content-between fw-bold my-2">
                                <span>繳費截止日期</span>
                                <span>{{ order.expireDate }} {{ order.expireTime }}</span>
                            </div>
                            <div class="d-flex justify-content-between fw-bold my-2">
                                <span>銀行代號</span>
                                <span>{{ order.bankCode }}</span>
                            </div>
                            <div class="d-flex justify-content-between fw-bold my-2">
                                <span>ATM轉帳帳號</span>
                                <span>{{ order.codeNo }}</span>
                            </div>
                        </div>
                        <div v-if="order.paymentType == 'BARCODE'">
                            <div class="d-flex justify-content-between fw-bold my-2">
                                <span>繳費截止日期</span>
                                <span>{{ order.expireDate }} {{ order.expireTime }}</span>
                            </div>
                            <div class="d-flex justify-content-center fw-bold my-2">
                                <barcode :value="order.barcode1" :text="order.barcode1" type="code128" :width="'2'"
                                         :height="'50'" :format="'code128'"/>
                            </div>
                            <div class="d-flex justify-content-center fw-bold my-2">
                                <barcode :value="order.barcode1" :text="order.barcode2" type="code128" :width="'2'"
                                         :height="'50'" :format="'code128'"/>
                            </div>
                            <div class="d-flex justify-content-center fw-bold my-2">
                                <barcode :value="order.barcode1" :text="order.barcode3" type="code128" :width="'2'"
                                         :height="'50'" :format="'code128'"/>
                            </div>
                        </div>
                        <div v-if="order.paymentType == 'CVS'">
                            <div class="d-flex justify-content-between fw-bold my-2">
                                <span>繳費截止日期</span>
                                <span>{{ order.expireDate }} {{ order.expireTime }}</span>
                            </div>
                            <div class="d-flex justify-content-between fw-bold my-2">
                                <span>繳費單代號</span>
                                <span>{{ order.codeNo }}</span>
                            </div>
                            <div class="d-flex justify-content-center fw-bold my-2">
                                <img :src="generateQRCode(order.codeNo)" alt="QR Code" v-if="order.codeNo"/>
                            </div>
                        </div>
                    </div>
                </el-card>
                <!--購買商品-->
                <el-card shadow="always" class="my-1">
                    <span class="fw-bold">購買商品</span>
                    <el-divider class="my-3"></el-divider>
                    <!--商品列表-->
                    <div style="font-size: 0.9rem" v-for="item in order.orderDetails" :key="item.id" class="my-2">

                        <div style="font-size: 0.8rem" v-if="item.isPreorder == 1">
                            <el-tag type="danger" size="mini" class="me-1">預購</el-tag>
                            <span style="font-size: 0.8rem;color: #909399">{{ item.shipDate }}天內出貨</span>
                        </div>
                        <div class="d-flex flex-column my-1">
                            <span
                                class="mb-2 fw-bold ">{{ item.name }}</span>

                            <div class="d-flex justify-content-between" style="font-size: 0.8rem;color: #909399">
                                <span>${{ item.salePrice.toLocaleString() }}</span>
                                <span>x {{ item.amount }}</span>
                            </div>
                        </div>
                    </div>
                    <el-divider class="my-3"></el-divider>
                    <!--運費-->
                    <div class="d-flex justify-content-between fw-bold" style="font-size: 0.9rem">
                        <span>運費及相關處理</span>
                        <span>${{ order.deliveryFee.toLocaleString() }}</span>
                    </div>
                    <el-divider class="my-3"></el-divider>
                    <!--總金額-->
                    <div class="d-flex justify-content-between fw-bold" style="font-size: 0.9rem">
                        <span>金額</span>
                        <span class="text-danger">${{ order.totalAmount.toLocaleString() }}</span>
                    </div>
                </el-card>
                <!--發票資訊-->
                <el-card shadow="always" class="my-1" v-if="order.companyName !=null || order.companyCode !=null">
                    <span class="fw-bold">發票資訊</span>
                    <el-divider class="my-2"></el-divider>
                    <div style="font-size: 0.9rem">
                        <div class="d-flex justify-content-between fw-bold my-2">
                            <span>公司抬頭</span>
                            <span>{{ order.companyName }}</span>
                        </div>
                        <div class="d-flex justify-content-between fw-bold my-2">
                            <span>統一編號</span>
                            <span>{{ order.companyCode }}</span>
                        </div>
                    </div>
                </el-card>
                <!--收件人資訊-->
                <el-card shadow="always" class="my-1">
                    <span class="fw-bold">收貨人資訊</span>
                    <el-divider class="my-3"></el-divider>
                    <div style="font-size: 0.9rem" class="fw-bold">
                        <div class="d-flex justify-content-between my-1">
                            <span class="mb-2">姓名</span>
                            <span>{{ order.sendName }}</span>
                        </div>
                        <div class="d-flex justify-content-between my-1">
                            <span class="mb-2">電話</span>
                            <span>{{ order.sendPhone }}</span>
                        </div>
                        <div class="d-flex justify-content-between my-1">
                            <span class="mb-2">地址</span>
                            <span>{{ order.sendAddress }}</span>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>

        <el-dialog title="退貨申請" :visible.sync="returnProductDialogVisible" width="70%"
                   @close="returnProductDialogVisible=false">
            <span>請敘述退貨原因</span>
            <el-input type="textarea" v-model="returnProducMemo" class="mt-2"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="returnProductDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="returnProduct">確定</el-button>
            </span>
        </el-dialog>
<!--        <el-dialog title="退貨申訴" :visible.sync="dialogVisible2" width="70%">-->
<!--            <span>請輸入申訴原因</span>-->
<!--            <el-input type="textarea" v-model="returnProducMemo" class="mt-2"></el-input>-->
<!--            <span slot="footer" class="dialog-footer">-->
<!--                <el-button @click="dialogVisible2 = false">取消</el-button>-->
<!--                <el-button type="primary" @click="dialogVisible2 = false">確定</el-button>-->
<!--            </span>-->
<!--        </el-dialog>-->
    </div>
</template>
<script>
import MENU from '@/components/storeMenu.vue'
import FN from '@/components/fn'
import VueBarcode from 'vue-barcode';
import QRCode from 'qrcode';
import fa from "element-ui/src/locale/lang/fa";
import {RETURN_ORDER} from "@/api";
import moment from 'moment/min/moment-with-locales'

export default {
    components: {
        MENU,
        'barcode': VueBarcode
    },
    mixins: [FN],
    data() {
        return {
            activeName: 'first',
            returnProductDialogVisible: false,
            // dialogVisible2: false,
            id: null,
            order: null,
            loading: true,
            returnProducMemo:""
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.getOrder();
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        showChatroom() {
            this.loading = true;
            this.FETCH({
                key: 'GET_CHATROOM_INFO',
                productId: this.order.orderDetails[0].productId,
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getChatroomInfo);
                }
                if (+(res || {}).code === 0) {
                    let channelId = res.data.channelId;
                    let channle = res.data.channle;
                    let showName = res.data.showName;
                    this.$router.push({
                        name: "StoreChatroom",
                        params: {id: channelId, channel: channle, showName: showName}
                    });

                } else {
                    console.log(res);
                    this.$message('網路不穩，請稍後重試。');
                }
                this.loading = false;
            })
        },
        getOrder() {
            this.loading = true;
            this.FETCH({
                key: 'GET_ORDER_DETAIL',
                id: this.id,
            }).then((res) => {
                //需要accToken的驗證
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getProduct)
                } else if (+(res || {}).code === 0) {

                    this.order = res.data;
                } else {
                    console.log('res');
                    this.$message('網路不穩，請稍後重試。');
                }
                this.loading = false;
            })
        },
        generateQRCode(text) {
            var QRcodeUrl = "";
            QRCode.toDataURL(text, (error, url) => {
                if (error) {
                    console.error(error);
                } else {
                    QRcodeUrl = url;
                }
            });
            return QRcodeUrl;
        },
        rechekout() {
            this.loading = true;
            this.FETCH({
                key: 'STORE_RECHECKOUT',
                orderId: this.id,

            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.rechekout());
                } else if (+(res || {}).code === 0) {
                    this.$refs.payForm.MerchantID.value = res.data.merchantID;
                    this.$refs.payForm.TradeInfo.value = res.data.tradeInfo;
                    this.$refs.payForm.TradeSha.value = res.data.tradeSha;
                    this.$refs.payForm.action = res.data.payUrl;
                    this.$refs.payForm.submit();
                } else {
                    this.$message('連線異常，請稍後重試');
                }
                this.loading = false;
            });

        },
        /** 退貨申請 **/
        returnProduct() {
            if(this.returnProducMemo.trim() ==''){
                    this.$message('請輸入退貨原因');
                return;
            }
            this.loading = true;
            this.returnProductDialogVisible= false;
            this.FETCH({
                key: 'RETURN_ORDER',
                orderId: this.id,
                memo: this.returnProducMemo,
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.returnProduct);
                }
                if (+(res || {}).code === 1) {
                    console.log(res);
                    this.$message('該筆訂單無法退貨，請聯絡客服。');
                }
                if (+(res || {}).code === 0) {
                    this.$message('申請退貨成功。');
                    this.getOrder();
                } else {
                    console.log(res);
                    this.$message('網路不穩，請稍後重試。');
                }
                this.loading = false;
            })
        },
        /**
         * 確認可申請退貨時間
         */
        checkCanReturnDate(payDate){
            payDate = moment(payDate).format('L');
            return moment(payDate).isBefore(moment().add(14, 'days').format('L'));
        }

    },
    computed: {
        isDetails() {
            const details = this.$route.name !== 'Store'
            return details
        },

    },

}
</script>





